import React from "react";
import styled from "styled-components";
import { func, node } from "prop-types";
import ExitButton from "components/shared/ExitButton";

const LightBoxContainer = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0);
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
  align-items: flex-start;
  animation: fade-in 1s forwards;

  @media (min-width: ${({ theme }) => theme.screen.mobile}px) {
    align-items: center;
  }

  @keyframes fade-in {
    from {
      background: rgba(0, 0, 0, 0);
    }
    to {
      background: rgba(0, 0, 0, 0.7);
    }
  }
`;

const LightBox = ({ children, open }) => (
  <LightBoxContainer data-testid="lightbox">
    {open && <ExitButton onClick={() => open(false)} />}
    {children}
  </LightBoxContainer>
);

LightBox.propTypes = {
  children: node.isRequired,
  open: func
};

export default LightBox;
